import contratApi from '@/api/contrat.api'
import store from '@/store'
import { numtiersCible } from '@/utils/destinataire'

const getDefaultState = () => {
  return {
    /**
     * {
        "BT": {
          "Prix campagne": {
            "contrats": [
              {
                "numeroContrat": 202100197,
                "numtiersLivre": "818773",
                "anneeRecolte": "2021",
                "type": {
                  "code": "CAR",
                  "categorieContrat": "Prix campagne",
                  "sousTypeContrat": "Prix campagne",
                  "logistique": "Livraison silo"
                },
                "codeIdaRs3": "BT",
                "quantiteLivreeEnKg": 0,
                "quantiteCibleEnKg": 25000.0,
                "quantiteFactureeEnKg": 0,
                "quantiteEchangeRestantEnKg": 0,
                "quantiteEchangeUtiliseeEnKg": 0,
                "commandeAlimentEnCours": false,
                "prixBaseEnEuro": 0.0,
                "dateSouscription": "2021-01-05",
                "etat": "à livrer"
              }
            ]
          }
        }
      }
     */
    // TODO Trier par nom de contrats ?
    contratResumeRs3AnneeRecolteEnCoursByTypePrix: {},
    resumesContrats: [],
    detailsContrat: {},
    repartitionPrixContratMoyens: {
      perso: {},
      quartiles: []
    },
    repartitionPrixVenteMoyens: {
      perso: {},
      quartiles: []
    },
    contratsResumeGlobal: {},
    evolutionPrixContratNumtiers: {},
    evolutionPrixContratGroupe: {},
    repartitionQuantiteCibleAdherent: {},
    repartitionQuantiteCibleGroupe: {},
    nbNouveauxContrats: 0
  }
}
const module = {
  namespaced: true,

  state: getDefaultState(),

  getters: {
    contratResumeRs3AnneeRecolteEnCoursByTypePrix (state) {
      return state.contratResumeRs3AnneeRecolteEnCoursByTypePrix
    },
    resumesContrats (state) {
      return state.resumesContrats
    },
    detailsContrat (state) {
      return state.detailsContrat
    },
    repartitionPrixContratMoyens (state) {
      return state.repartitionPrixContratMoyens
    },
    repartitionPrixVenteMoyens (state) {
      return state.repartitionPrixVenteMoyens
    },
    contratsResumeGlobal (state) {
      return state.contratsResumeGlobal
    },
    evolutionPrixContratNumtiers (state) {
      return state.evolutionPrixContratNumtiers
    },
    evolutionPrixContratGroupe (state) {
      return state.evolutionPrixContratGroupe
    },
    repartitionQuantiteCibleAdherent (state) {
      return state.repartitionQuantiteCibleAdherent
    },
    repartitionQuantiteCibleGroupe (state) {
      return state.repartitionQuantiteCibleGroupe
    },
    nbNouveauxContrats (state) {
      return state.nbNouveauxContrats
    }
  },
  mutations: {
    UPDATE_CONTRAT_RECOLTE_EN_COURS (state, contratResume) {
      state.contratResumeRs3AnneeRecolteEnCoursByTypePrix = contratResume
    },
    UPDATE_RESUMES_CONTRATS (state, resumesContrats) {
      state.resumesContrats = resumesContrats
    },
    UPDATE_DETAILS_CONTRAT (state, detailsContrat) {
      state.detailsContrat = detailsContrat
    },
    UPDATE_REPARTITION_PRIX_CONTRAT_MOYENS (state, repartitionPrixContratMoyens) {
      state.repartitionPrixContratMoyens = repartitionPrixContratMoyens
    },
    UPDATE_REPARTITION_PRIX_VENTE_MOYENS (state, repartitionPrixVenteMoyens) {
      state.repartitionPrixVenteMoyens = repartitionPrixVenteMoyens
    },
    UPDATE_CONTRATS_RESUME_GLOBAL (state, contratsResumeGlobal) {
      state.contratsResumeGlobal = contratsResumeGlobal
    },
    UPDATE_EVOLUTION_PRIX_CONTRAT_NUMTIERS (state, evolutionPrixContratNumtiers) {
      state.evolutionPrixContratNumtiers = evolutionPrixContratNumtiers
    },
    UPDATE_EVOLUTION_PRIX_CONTRAT_GROUPE (state, evolutionPrixContratGroupe) {
      state.evolutionPrixContratGroupe = evolutionPrixContratGroupe
    },
    UPDATE_REPARTITION_QUANTITE_CIBLE_NUMTIERS (state, repartitionQuantiteCibleAdherent) {
      state.repartitionQuantiteCibleAdherent = repartitionQuantiteCibleAdherent
    },
    UPDATE_REPARTITION_QUANTITE_CIBLE_GROUPE (state, repartitionQuantiteCibleGroupe) {
      state.repartitionQuantiteCibleGroupe = repartitionQuantiteCibleGroupe
    },
    UPDATE_NB_NOUVEAUX_CONTRATS (state, nbNouveauxContrats) {
      state.nbNouveauxContrats = nbNouveauxContrats
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    getResumesContrats ({ rootGetters, commit, dispatch }, params) {
      const username = numtiersCible(rootGetters)
      return contratApi.getAllResumeContratByAnneeAndGraine(username, params.anneeRecolte, params.codeGraineRs3)
        .then(resumesContrats => {
          const numeroContratFiltre = store.getters['filtresContrat/filtresAdherent'].numeroContrat
          commit('UPDATE_RESUMES_CONTRATS', resumesContrats)
          const param = {
            resumesContrats: resumesContrats,
            numeroContrat: params.numeroContrat ? params.numeroContrat : numeroContratFiltre,
            categorieContrat: params.categorieContrat,
            etatLogistique: params.etatLogistique
          }
          dispatch('filtresContrat/initFiltres', param, { root: true })
          return resumesContrats
        })
    },
    getDetailsContrat ({ rootGetters, commit }, contrat) {
      const username = numtiersCible(rootGetters)

      if (contrat?.type?.code) {
        let promise

        switch (contrat.type.code) {
          case 'CAMPAGNE_NON_ENGAGE':
            promise = contratApi.getDetailsContratAssimilePrixCampagneNonEngage(username, contrat.anneeRecolte, contrat.codeGraineRs3)
            break
          case 'TRESO_MOISSON_A_FIXER':
            promise = contratApi.getDetailsContratAssimileTresoMoissonAFixer(username, contrat.anneeRecolte, contrat.codeGraineRs3)
            break
          default:
            promise = contratApi.getDetailsContratByNumeroContrat(username, contrat.numeroContrat, contrat.numeroOrdreContrat)
            break
        }

        return promise.then(detailsContrat => {
          commit('UPDATE_DETAILS_CONTRAT', detailsContrat)
          return detailsContrat
        })
      } else {
        throw new Error('Erreur de construction de l\'objet : ' + contrat)
      }
    },
    getDocumentPdf ({ rootGetters }, numeroContrat) {
      const username = numtiersCible(rootGetters)
      return contratApi.getDocumentPdf(username, numeroContrat)
    },
    getDocumentFileName ({ rootGetters }, numeroContrat) {
      const username = numtiersCible(rootGetters)
      return contratApi.getDocumentFileName(username, numeroContrat)
    },
    fetchContratResumeRs3AnneeRecolteEnCoursByTypePrix ({ commit, rootGetters }) {
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      let codeGraineRs3 = rootGetters['application/codeGraineActive']
      const username = numtiersCible(rootGetters)
      return contratApi.fetchContratResumeRs3ByTypePrix(username, anneeRecolte, codeGraineRs3).then(contratResume => {
        commit('UPDATE_CONTRAT_RECOLTE_EN_COURS', contratResume)
        return contratResume
      })
    },
    fetchContratsResumeGlobalRs3AnneeRecolte ({ commit, rootGetters }) {
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      let codeGraineRs3 = rootGetters['application/codeGraineActive']
      const username = numtiersCible(rootGetters)
      return contratApi.fetchContratsResumeGlobalRs3AnneeRecolte(username, anneeRecolte, codeGraineRs3).then(contratsResumeGlobal => {
        commit('UPDATE_CONTRATS_RESUME_GLOBAL', contratsResumeGlobal)
        return contratsResumeGlobal
      })
    },
    getPrixContratMoyenComparaison ({ commit, rootGetters }, { filtres }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      let codeGraineRs3 = rootGetters['application/codeGraineActive']
      return contratApi.getPrixContratMoyenComparaison(username, anneeRecolte, codeGraineRs3, filtres)
        .then(result => {
          commit('UPDATE_REPARTITION_PRIX_CONTRAT_MOYENS', result)
          return result
        })
    },
    getPrixVenteMoyenComparaison ({ commit, rootGetters }, params) {
      const username = numtiersCible(rootGetters)
      return contratApi.getPrixVenteMoyenComparaison(username, params)
        .then(result => {
          commit('UPDATE_REPARTITION_PRIX_VENTE_MOYENS', result)
          return result
        })
    },
    getEvolutionPrixContratNumtiers ({ commit, rootGetters }) {
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      let codeGraineRs3 = rootGetters['application/codeGraineActive']
      const username = numtiersCible(rootGetters)
      return contratApi.getEvolutionPrixContratNumtiers(username, anneeRecolte, codeGraineRs3)
        .then(result => {
          commit('UPDATE_EVOLUTION_PRIX_CONTRAT_NUMTIERS', result)
          return result
        })
    },
    getEvolutionPrixContratGroupe ({ commit, rootGetters }, { filtres }) {
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      let codeGraineRs3 = rootGetters['application/codeGraineActive']
      const username = numtiersCible(rootGetters)
      return contratApi.getEvolutionPrixContratGroupe(username, anneeRecolte, codeGraineRs3, filtres)
        .then(result => {
          commit('UPDATE_EVOLUTION_PRIX_CONTRAT_GROUPE', result)
          return result
        })
    },
    getRepartitionQuantiteCibleContratAdherent ({ commit, rootGetters }) {
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      let codeGraineRs3 = rootGetters['application/codeGraineActive']
      const username = numtiersCible(rootGetters)
      return contratApi.getRepartitionQuantiteCibleContratAdherent(username, anneeRecolte, codeGraineRs3)
        .then(result => {
          commit('UPDATE_REPARTITION_QUANTITE_CIBLE_NUMTIERS', result)
          return result
        })
    },
    getRepartitionQuantiteCibleContratGroupe ({ commit, rootGetters }, { filtres }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      let codeGraineRs3 = rootGetters['application/codeGraineActive']
      return contratApi.getRepartitionQuantiteCibleContratGroupe(username, anneeRecolte, codeGraineRs3, filtres)
        .then(result => {
          commit('UPDATE_REPARTITION_QUANTITE_CIBLE_GROUPE', result)
          return result
        })
    },
    getNbNouveauxContrats ({ commit }, nbNouveauxContrats) {
      commit('UPDATE_NB_NOUVEAUX_CONTRATS', nbNouveauxContrats)
    },
    reset ({ commit }) {
      commit('RESET')
    },
  }
}

export default module
